import { shallowRef } from 'vue';
import type { RouteRecordRaw } from 'vue-router';

import { PAGES as ROOT_PAGES } from '@utils/constants';
import type { Module } from '@utils/model';

import { PAGES } from './constants';

import ModuleIcon from '~icons/mdi/cellphone-cog';

const routes: RouteRecordRaw[] = [
	{
		path: '/sdui',
		name: PAGES.HOME,
		component: () => import('./pages/index.vue'),
		meta: {
			// Checked synchronously in the router's global guard, so a direct navigation cannot reach the
			// page before the layout's post-mount redirect fires.
			isAllowed: ({ canAccessSduiAdmin }) => canAccessSduiAdmin || ROOT_PAGES.MODULES,
			documentTitle: 'SDUI Admin',
			title: 'SDUI Admin',
		},
	},
];

/**
 * SDUI Admin is not built in this repository: it is motorway/mw-sdui-admin, loaded at runtime as a
 * Module Federation remote (lib/remote.ts). Gated on the Developer and Admin roles rather than a
 * permission of its own; see `canAccessSduiAdmin` in src/core/services/user/store.ts.
 */
export const SDUI_ADMIN_MODULE: Module = {
	id: PAGES.HOME,
	link: { name: PAGES.HOME },
	title: 'SDUI Admin',
	icon: shallowRef(ModuleIcon),
	enabled: ({ canAccessSduiAdmin }) => canAccessSduiAdmin,
	routes,
};
